import {
  MimaButton,
  MimaDropdown,
  ReceiptCheckBox as RCB,
  MimaText,
  Modal,
  MimaInput,
} from "../../components";
import styles from "../../assets/styles/Prospect/Prospect.module.scss";
import successImg from "../../assets/img/Successful.png";
import { Formik } from "formik";

import React from "react";

const AddBulkProspect = ({
  closeModal,
  uploaded,
  validationSchema,
  uploadClick,
  file,
  selectClick,
  loading,
}) => {
  return (
    <Modal closeModal={closeModal} goBack={closeModal}>
      <MimaText variant="subtitle" mb={3}>
        Add Bulk Prospects
      </MimaText>
      {!uploaded && (
        <>
          <MimaText
            variant="small"
            mb={2}
            width={38}
            align="center"
            color="var(--color-primary)"
          >
            To add Prospects in bulk kindly click the button below and download
            our excel template.
          </MimaText>

          <a
            href="https://docs.google.com/spreadsheets/d/1zd4QaFfiN4o3mt4tBWXb3DXd9CAJw9exclfK0TfOw9A/edit?gid=0#gid=0"
            target="_blank"
            rel="noreferrer"
          >
            <MimaButton
              title="Download Template"
              variant="colorable"
              buttonColor="var(--color-dark)"
              mb={5}
            />
          </a>

          <MimaText
            variant="small"
            mb={2}
            width={38}
            align="center"
            color="var(--color-primary)"
          >
            Fill the downloaded template with your prospects information and
            then upload in the next button
          </MimaText>
          <Formik
            initialValues={{}}
            // validationSchema={validationSchema}
            onSubmit={uploadClick}
          >
            {({
              handleChange,
              handleBlur,
              handleSubmit,
              setFieldValue,
              values,
              errors,
              touched,
            }) => (
              <div>
                <MimaButton
                  title="Select file"
                  variant="outlined"
                  width={38}
                  onClick={selectClick}
                />
                <MimaText
                  variant="small"
                  mt={2}
                  width={38}
                  align="center"
                  color="var(--color-primary)"
                >
                  {file?.name || ""}{" "}
                </MimaText>
                <MimaButton
                  disabled={loading}
                  loading={loading}
                  title="Upload Prospects Info"
                  type="submit"
                  onClick={handleSubmit}
                  variant="form"
                />

                {/* <MimaInput
                  labelTitle="prospect"
                  name="prospects"
                  value={values.prospects}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={errors.prospects}
                  touched={touched.prospects}
                /> */}
              </div>
            )}
          </Formik>
        </>
      )}
      {uploaded && (
        <>
          <img
            src={successImg}
            alt="Upload success"
            className={styles.success}
          />
          <MimaText
            variant="h3"
            width={38}
            align="center"
            color="var(--color-success)"
            mb={2}
          >
            Upload <br />
            Successful
          </MimaText>

          <MimaButton
            title="Continue"
            onClick={closeModal}
            mt={3}
            variant="form"
          />
        </>
      )}
    </Modal>
  );
};

export default AddBulkProspect;
